import * as React from 'react';
import {
    SearchAlreadyCreatedCardsDocument,
    SearchAlreadyCreatedCardsQuery,
    SearchAlreadyCreatedCardsQueryVariables,
    SearchTopicsDocument,
    SearchTopicsQuery,
    SearchTopicsQueryVariables,
    TopicQueryResult,
    useCreateTopicMutation,
    useTopicQuery,
    useTopicsByIdsQuery,
    useUpdateTopicMutation
} from "../../../../types.d";
import {Form} from "@intelingu/core/components/form/Form";
import {FormGroup} from "../../../partials/form/elements/FormGroup";
import {Field} from "@intelingu/core/components/form/Field";
import {TextInput} from "../../../partials/form/elements/TextInput";
import {SubmitButton} from "../../../partials/form/elements/SubmitButton";
import {IsNotEmpty, Validate} from "class-validator";
import {MceValidator} from "../../../../utils/mceValidator";
import {TinyMCE} from "../../../partials/form/elements/TinyMCE";
import {graphql} from "../../../../configs/graphql.client";
import Async from 'react-select/async';
import debounce from "debounce-promise";

class Validator {

    @IsNotEmpty()
    title: string;

    @Validate(MceValidator)
    description: string;

}

export const EditTopic = (props: { stageId: number, topicId?: number }) => {
    const id = props.topicId;
    let item: TopicQueryResult;

    const [ createTopic, { data: createdTopic } ] = useCreateTopicMutation();
    const [ updateTopic, { data: updatedTopic } ] = useUpdateTopicMutation();

    if (id) {
        item = useTopicQuery({
            variables: { id }
        });
    }

    if (item && !item.data) {
        return null;
    }

    return <div>
        <Form
            validator={Validator}
            defaultData={item ? {
                title: item.data.topic.title,
                description: item.data.topic.description,
                relatedTopics: item.data.topic.relatedTopics
            } : {
                stage: props.stageId
            }}
            onSubmit={async (data, done) => {
                if (id) {
                    await updateTopic({
                        variables: { id, input: data }
                    });
                } else {
                    await createTopic({
                        variables: { input: data }
                    });
                }

                done();
            }}>

            <FormGroup label={'Name of Topic Block'} required={true}>
                <Field
                    name={'title'}
                    render={props => <TextInput {...props} />} />
            </FormGroup>

            <FormGroup label={'Text'} required={true}>
                <Field
                    name={'description'}
                    render={props => <TinyMCE
                        height={450}
                        toolbar={'undo redo | formatselect | bold italic backcolor | \
                            alignleft aligncenter alignright alignjustify | \
                            bullist numlist outdent indent | removeformat | table | audio | preview | help'}
                        {...props} />} />
            </FormGroup>

            <FormGroup label={'Related Topics'}>
                <Field
                    name={'relatedTopics'}
                    render={props => <RelatedTopicsField {...props} />} />
            </FormGroup>

            <div className={'col-12'}>
                <Field submit render={props => <SubmitButton {...props}>Done</SubmitButton>} />
            </div>
        </Form>
    </div>
};

export const RelatedTopicsField = (props: { onChange, value }) => {
    console.log(props.value);

    const value = props.value ? props.value
        .split(',')
        .map(item => Number(item)) : [];

    const topics = useTopicsByIdsQuery({
        skip: !value.length,
        variables: {
            ids: value
        }
    });

    if (value.length && !topics.data) {
        return null;
    }

    const formattedTopics = topics.data ? topics.data.topicsByIds.map(item => ({
        label: item.title,
        value: item.id
    })) : [];

    return <Async
        isMulti
        defaultValue={formattedTopics}
        loadOptions={debounce(async (query) => {
            const result = await graphql.client.query<SearchTopicsQuery, SearchTopicsQueryVariables>({
                query: SearchTopicsDocument,
                variables: {
                    query,
                }
            });

            return result.data.searchTopics.map(result => ({
                label: result.title,
                value: result.id
            }));
        }, 300)}
        defaultOptions={formattedTopics}
        onChange={value => {
            props.onChange(value.map(item => item.value).join(','));
        }}
        options={value} />
};
